module.exports = "<section class=\"has-padding-large\">\r\n  <span>{{'not-authorized.usuario-sin-credenciales-pagina' | translate}}</span>\r\n</section>\r\n"